module.exports = __webpack_public_path__ + "static/img/md.5a4de52c.png";